<form #form="ngForm">
    <app-layout-row>
        <app-layout-column [width]="12">
            @for (protocol of usedTransportProtocols(); track $index)
            {
                <app-layout-row>
                    <app-layout-column [width]="12">
                        <app-section-box [disabled]="disabled()" [title]="protocol" (titleActionClicked)="removeTransportProtocol(protocol)" [showFooter]="false">
                            <div header></div>
                            <div body>
                            @if (protocol === 'SFTP') {
                                <app-sftp-protocol-viewer [disabled]="disabled()" [name]="'protocol-' + protocol" [ngModel]="sftpTransports()" (ngModelChange)="formChanged()"></app-sftp-protocol-viewer>
                            } @else if (protocol === 'AS2') {
                                <app-as2-protocol-viewer [disabled]="disabled()" [name]="'protocol-' + protocol" [ngModel]="as2Transport()" (ngModelChange)="formChanged()"></app-as2-protocol-viewer>
                            } @else if (protocol === 'FTP') {
                                <app-ftp-protocol-viewer [disabled]="disabled()" [name]="'protocol-' + protocol" [ngModel]="ftpTransports()" (ngModelChange)="formChanged()"></app-ftp-protocol-viewer>
                            } @else {
                                <p>Unknown protocol: {{protocol}}</p>
                            }
                            </div>
                            <div footer></div>
                        </app-section-box>
                    </app-layout-column>
                </app-layout-row>
            }

            <div class="add-transport-protocol-section">
                @if (showAddTransportProtocol) {
                    <app-singleselectbox 
                        [ngModel]="selectedTransportProtocol()"
                        name="select-transport-protocol"
                        caption="Choose which transport protocols your partner can select from" 
                        [dataSource]="transportProtocolsToSelectFrom()"
                        (ngModelChange)="transportProtocolChanged($event)">
                    </app-singleselectbox>
                    <app-button primary width="10rem" (buttonClick)="addSelectedTransportProtocolClicked()">Add</app-button>
                } @else {
                    <app-link iconClass="dx-icon-add" [disabled]="disabled() || transportProtocolsToSelectFrom()?.length === 0" (onClick)="addMoreTransportProtocolsClicked()">Add more transport protocols</app-link>
                }
            </div>
            
        </app-layout-column>
    </app-layout-row>
</form>
